import styled from 'styled-components';

const CardStyles = styled.div`
  border-radius: ${props =>
    props.borderRadius || props.theme.borderRadiuses.card};
  box-shadow: ${props => props.shadow || props.theme.shadows.mid};
  box-sizing: border-box;
  background: ${props => props.theme.colors.white};

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

export default CardStyles;
